import { useEffect, useRef } from 'react';
import './CustomSideBar.css'
export const CustomSideBar = ({ sideBarRef, isOpen, setIsOpen, onClose }) => {

    useEffect(() => {
        function handleClickOutside(event) {
            if (!sideBarRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);
    return (
        <>
            <div className={`sidebar ${isOpen ? 'open' : ''}`}>
                <span className="sidebar-toggle close-btn" onClick={onClose}>
                    <i className="fa fa-bars" aria-hidden="true"></i>
                </span>
            </div>
        </>
    );
};